"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeviceDetect = void 0;

var _react = require("react");

const MOBILE_DEVICES = /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i;

const getUserAgent = () => typeof window.navigator === 'undefined' ? '' : navigator.userAgent;

const isMobileDevice = userAgent => Boolean(userAgent.match(MOBILE_DEVICES));

const useDeviceDetect = () => {
  const [isMobile, setIsMobile] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const userAgent = getUserAgent();
    setIsMobile(isMobileDevice(userAgent));
  }, []);
  return {
    isMobile
  };
};

exports.useDeviceDetect = useDeviceDetect;